import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" actions: the intents the page dispatches for the saga to act on.
 * Kept out of the slice's reducers: they trigger a side effect, not a state
 * transition (the saga owns the resulting transitions).
 */

/** Fetch the client imports listing and its summary (dispatched on mount). */
export const importsRequested = createAction('imports/importsRequested');

/** Send the "Contact My Customer Success Manager" form (#695). */
export const csmMessageSubmitted = createAction<{ message: string }>('imports/csmMessageSubmitted');
